import React from "react";
import "./Footer.css";

export default function Footer({ name }) {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <span className="footer__logo">{name.split(" ")[0]}<span>.</span></span>
        <p className="footer__copy">
          Designed &amp; built by <span>{name}</span> · {new Date().getFullYear()}
        </p>
        <p className="footer__stack">React.js · MERN Stack</p>
      </div>
    </footer>
  );
}
